<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <label for="{{controlId}}" class="control-label" *ngIf="!mobilePhones && showLabel">
      <span i18n="@@phones">Phones</span>&nbsp;<span *ngIf="showRequired">**</span>
    </label>

    <label for="{{controlId}}" class="control-label" *ngIf="mobilePhones && showLabel">
      <span i18n="@@mobilePhones">Mobile phones</span>&nbsp;<span *ngIf="showRequired">**</span>
    </label>

    &nbsp;

    <button mat-icon-button color="primary" matTooltipPosition="above" i18n-matTooltip="@@phoneNumberInfo"
            matTooltipClass="tooltip-custom"
            matTooltip="The phone number must start with the country code. Ex: +33xxxxxxxxx, +41xxxxxxxxx">
      <mat-icon>info</mat-icon>
    </button>

    <mat-form-field class="chip-list">

      <mat-chip-grid #phonesChipList>
        <mat-chip-row color="primary"  *ngFor="let d of data" [removable]="allowRemove" (removed)="remove(d)">
          {{d?.number}}

        </mat-chip-row>

        <input id="{{controlId}}"   [disabled]="!allowAdd" [matChipInputAddOnBlur]="addOnBlur"
               [matChipInputFor]="phonesChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
               (matChipInputTokenEnd)="add($event)">
      </mat-chip-grid>


      <mat-error *ngIf="isRequired" i18n="@@requiredInput">This input is required.</mat-error>
      <mat-error *ngIf="notMatchPattern" i18n="@@phoneNumberPattern">Wrong format expects: +33xxxxxxxxx.</mat-error>
    </mat-form-field>

  </div>
</div>
